var _ellipse, _path, _ellipse2, _ellipse3, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgELearning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52,
    cy: 52,
    rx: 52,
    ry: 52,
    fill: "#243CBB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.9771 62.178C99.2865 55.5429 99.0942 48.9597 97.6359 42.7802M95.9142 37.1401C95.199 35.2442 94.3605 33.4014 93.4065 31.6233C92.6972 30.3015 91.9241 29.0154 91.0903 27.7699",
    stroke: "white",
    strokeWidth: 2.08014,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.2146,
    cy: 60.8537,
    rx: 32.9104,
    ry: 32.9104,
    fill: "#22FFAA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_248_29103",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 104,
    height: 104
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52,
    cy: 52,
    rx: 52,
    ry: 52,
    fill: "#243CBB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_248_29103)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 34.2959,
    width: 74.6934,
    height: 54.0465,
    rx: 3.8136,
    fill: "#D7DEEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4485 80.1295H23.7298V92.4924C23.7298 95.277 21.4725 97.5343 18.6879 97.5343H18.5728C16.4367 97.5343 14.7051 99.2659 14.7051 101.402C14.7051 103.538 16.4367 105.27 18.5728 105.27H56.6054C58.7415 105.27 60.4731 103.538 60.4731 101.402C60.4731 99.2659 58.7415 97.5343 56.6054 97.5343H55.9608C53.4687 97.5343 51.4485 95.5141 51.4485 93.022V80.1295Z",
    fill: "#060C23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.85791,
    y: 34.296,
    width: 69.8353,
    height: 54.0465,
    rx: 3.8136,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8584 83.0659H74.6937V84.5289C74.6937 86.6351 72.9863 88.3425 70.8801 88.3425H8.67199C6.5658 88.3425 4.8584 86.6351 4.8584 84.5289V83.0659Z",
    fill: "#E4E9F1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1064 22.7227H60.7657V18.8067C60.7657 18.3014 60.5809 17.7962 60.2113 17.4172C59.8417 17.0382 59.3489 16.8488 58.8561 16.8488H43.4568C42.964 16.8488 42.4712 17.0382 42.1016 17.4172C41.732 17.7962 41.5472 18.3014 41.5472 18.8067V22.7858H39.2065V18.8067C39.2065 17.6698 39.6377 16.533 40.4385 15.7119C41.2393 14.8908 42.2864 14.4487 43.4568 14.4487H58.8561C60.0265 14.4487 61.0737 14.8908 61.8744 15.7119C62.6752 16.533 63.1064 17.6067 63.1064 18.8067V22.7227Z",
    fill: "#060C23",
    stroke: "#060C23",
    strokeWidth: 2.08014
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0059 61.4371H16.4185V70.5524H86.0059V61.4371Z",
    fill: "#E4E9F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0059 22.6063H16.4185V63.1609H86.0059V22.6063Z",
    fill: "#060C23"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0059 61.4371H16.4185V64.546H86.0059V61.4371Z",
    fill: "#2E293D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0059 69.1092H16.4185V72.2182H86.0059V69.1092Z",
    fill: "#2E293D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.0059 26.0884C86.0059 27.5891 85.45 29.0898 84.2828 30.257C83.1156 31.4242 81.615 31.98 80.1143 31.98H22.31C20.8094 31.98 19.3087 31.4242 18.1415 30.257C16.9743 29.0898 16.4185 27.5891 16.4185 26.0884V19.0268C16.4185 18.261 17.0393 17.6401 17.8052 17.6401H84.6191C85.385 17.6401 86.0059 18.261 86.0059 19.0268V26.0884Z",
    fill: "#2E293D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3145 16.5836V54.4744L33.0935 57.2534L35.8726 54.4744V16.5836H30.3145Z",
    fill: "#22FFAA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4971 16.5834V54.4742L69.3317 57.2533L72.1107 54.4742V16.5834H66.4971Z",
    fill: "#22FFAA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4281 42.8006C36.039 42.4115 35.4832 42.1892 34.9273 42.1892H31.2587C30.7029 42.1892 30.2026 42.4115 29.7579 42.8006C29.3688 43.1897 29.1465 43.7456 29.1465 44.3014V49.3596H29.9803V48.5259V44.357C29.9803 44.0235 30.0914 43.7456 30.3138 43.4677C30.5361 43.2453 30.8696 43.1341 31.1475 43.1341H34.8161C35.1496 43.1341 35.4276 43.2453 35.7055 43.4677C35.9278 43.69 36.039 44.0235 36.039 44.357V48.5259V49.3596H37.0395V44.3014C37.0395 43.69 36.8172 43.1897 36.4281 42.8006Z",
    fill: "#243CBB",
    stroke: "#243CBB",
    strokeWidth: 0.693381
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6112 42.8006C72.2221 42.4115 71.7218 42.1892 71.1104 42.1892H67.4418C66.886 42.1892 66.3301 42.4115 65.941 42.8006C65.5519 43.1897 65.3296 43.7456 65.3296 44.3014V49.3596H66.2189V48.5259V44.357C66.2189 44.0235 66.3301 43.7456 66.5525 43.4677C66.7748 43.2453 67.1083 43.1341 67.4418 43.1341H71.1104C71.4439 43.1341 71.7218 43.2453 71.9442 43.4677C72.1665 43.69 72.3333 44.0235 72.3333 44.357V48.5259V49.3596H73.167V44.3014C73.2226 43.69 73.0003 43.1897 72.6112 42.8006Z",
    fill: "#243CBB",
    stroke: "#243CBB",
    strokeWidth: 0.693381
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2615 65.8282H29.9248V75.4999L33.0931 72.3316L36.2615 75.4999V65.8282Z",
    fill: "#243CBB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgELearning);
export default __webpack_public_path__ + "static/media/e-learning.6470b0a6de5f0673dd6e136a765b1ea7.svg";
export { ForwardRef as ReactComponent };